import { Dropdown, Offcanvas } from "bootstrap"

$(() => {
  const $NavOffcanvasButton = $('.nav-offcanvas-button')
  const NavbarOffcanvas = document.querySelector('#navbar-offcanvas')
  const NavbarOffcanvasInstance = new Offcanvas(NavbarOffcanvas)

  NavbarOffcanvas.addEventListener('show.bs.offcanvas', () => {
    $NavOffcanvasButton.addClass('active')
  })

  NavbarOffcanvas.addEventListener('hide.bs.offcanvas', () => {
    $NavOffcanvasButton.removeClass('active')
  })

  $('#navbar-offcanvas a[href^="#"]').on('click', function(e) {
    e.preventDefault()
    NavbarOffcanvasInstance.hide()
  })

  $('.navbar-nav .dropdown').each(function(index, element) {
    const $element = $(element)
    const dropdown = new Dropdown(element.querySelector('.dropdown-toggle'))

    $element.on('mouseenter', function(e) {
      dropdown.show()
    })

    $element.on('mouseleave', function(e) {
      dropdown.hide()
    })
  })

  const $fixedButton = $(".fixed-button")
  if(document.querySelector('.section-fv')) {
    const $sectionFv = $(".section-fv")
    $(window).on('load scroll', function() {
      if(window.scrollY >= $sectionFv.height()) {
        $fixedButton.fadeIn()
      }else {
        $fixedButton.fadeOut()
      }
    })
  }else {
    $(window).on('load scroll', function() {
      if(window.scrollY >= window.innerHeight / 2) {
        $fixedButton.fadeIn()
      }else {
        $fixedButton.fadeOut()
      }
    })
  }

})